<template>
    <div>
        <transition-group
            v-if="loading && !items.length"
            mode="out-in"
            name="lb-project-list"
            tag="div"
            class="columns is-multiline is-mobile mx-0"
            appear
        >
            <div
                v-for="i in 20"
                :key="i"
                class="column is-12-mobile is-6-tablet is-4-widescreen"
            >
                <div class="lb-project-box is-loading"></div>
            </div>
        </transition-group>
        <section v-else>
            <projects-grid
                ref="gridProjects"
                :projects="items"
                :showCreationCard="canSowCreationCard"
                @deleteProject="deleteProject"
            />
        </section>
    </div>
</template>

<script>
import ProjectsGrid from '@/components/ProjectsGrid';
import _ from 'underscore';
export default {
    components: {
        ProjectsGrid,
    },
    props: {
        items: { type: Array, default: () => [] },
        loading: {
            type: Boolean,
            default: true,
        },
        activeFilter: {
            type: String,
            default: '',
        },
    },
    data() {
        return {};
    },
    computed: {
        canSowCreationCard() {
            console.log(this.activeFilter);
            if (this.activeFilter == 'mine') {
                return true;
            }
            return false;
        },
    },
    methods: {
        deleteProject(projectId) {
            this.$emit('delete', projectId);
        },
        selectProject(project) {
            this.$refs.gridProjects.selectProject(project);
        },
    },
};
</script>

<style scoped>
router-link {
    cursor: pointer;
}
</style>
